import { OutlineButtonStyle } from "./styled";

export const OutlineButton = ({ text, icon, event, isBIg }) => (
  <OutlineButtonStyle onClick={event ? () => event() : null} isBIg={isBIg}>
    {icon ? <img src={icon} alt="" /> : null}
    {text}
  </OutlineButtonStyle>
);
